import { render, staticRenderFns } from "./storeDetail.vue?vue&type=template&id=070bf238&scoped=true"
import script from "./storeDetail.vue?vue&type=script&lang=js"
export * from "./storeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bf238",
  null
  
)

export default component.exports